import { loadManifest } from '@angular-architects/module-federation';
let env = 'prod'

loadManifest(`/assets/mf.manifest-${env}.json`)
	.catch(err => console.error(err))
	.then(_ => import('./bootstrap'))
	.catch(err => console.error(err));
